import { useMemo, useCallback } from 'react'
import ModalProviders from '../common/providers/ModalProviders'
import CommonDrawerContextProviders, { useLinkedCommonDrawerState } from '../common/context/CommonDrawerContexts'
import { globalDispatch } from '../common/utils/Sparky'
import { LoadingPlaceholder } from '@sparky/framework'
import Header from './Header'
import Devices from '../devices'
import MessageProvider from '../common/providers/MessageProvider'
import { VIEW_DEVICE_ASSOCIATIONS } from '../common/constants/GlobalConstants'
import { Sheet } from '@panwds/react-ui'
import { setSidecarOptions } from '../common/reducers/actions/ViewReducer.actions'
import ManageTags from '../devices/components/sidecar/ManageTags'
import AssociateApps from '../devices/components/sidecar/AssociateApps'
import type { VFC } from 'react'
import type { CommonModuleProps } from '../common/types'
import { selectTreeNode } from '../common/reducers/actions/TreeReducer.actions'

const DeviceAssociation: VFC<CommonModuleProps> = ({ auth, commonModule }) => {
  const {
    treeReducer,
    viewReducer,
    instanceReducer,
    appReducer,
    licenseReducer,
    iamReducer,
    deviceReducer,
    subscriptionReducer,
    dispatch,
    initializing,
  } = useLinkedCommonDrawerState()

  const props = useMemo(() => {
    const onBreadCrumbClick = (obj: any) => {
      dispatch(selectTreeNode(obj))
    }
    return {
      ...appReducer,
      ...treeReducer,
      ...viewReducer,
      ...instanceReducer,
      dispatch,
      iamReducer,
      licenseReducer,
      deviceReducer,
      globalDispatch,
      onBreadCrumbClick,
      commonModule: {
        ...commonModule,
        path: VIEW_DEVICE_ASSOCIATIONS,
        visible: true,
      },
      subscriptionReducer,
      inCommonServicesPage: true,
      auth
    }
  }, [appReducer, auth, commonModule, deviceReducer, dispatch, iamReducer, instanceReducer, licenseReducer, subscriptionReducer, treeReducer, viewReducer])

  const header = useMemo(() => <Header title='Device Associations' />, [])

  const onSidecarClose = useCallback(() => {
    dispatch(setSidecarOptions(false))
  }, [dispatch])

  const sheetBody = useMemo(() => {
    switch (props?.sidecar?.body) {
      case 'tags':
        return <ManageTags {...{ onSidecarClose, sidecar: props?.sidecar }} />
      case 'apps':
        return <AssociateApps {...{ onSidecarClose, sidecar: props?.sidecar }} />
      default:
        return <></>
    }
  }, [props?.sidecar, onSidecarClose])

  if (initializing) {
    return <LoadingPlaceholder />
  }
  return (
    <div className='cm-w-full cm-h-full cm-flex cm-flex-col'>
      <CommonDrawerContextProviders>
        <ModalProviders>
          <div id='cloud-mgm-sidecar-container' className='cm-absolute cm-flex cm-inset-0 cm-justify-end'>
            <Sheet
              showMask
              isOpen={Boolean(props?.sidecar?.isOpen)}
              title={props?.sidecar?.title}
              onClose={onSidecarClose}
            >
              {sheetBody}
            </Sheet>
          </div>
          {header}
          <div className='cm-relative cm-flex-1 cm-bg-white dark:cm-bg-gray-1050'>
            <MessageProvider>
              <Devices {...props} />
            </MessageProvider>
          </div>
        </ModalProviders>
      </CommonDrawerContextProviders>
    </div>
  )
}
export default DeviceAssociation
